import { CaseColorStatus } from "../context/RegistryContexts/RegistryColorsContext";

const ONE_MINUTE_IN_MILLIS = 60 * 1000;

function dateStringToMillis(dateStr?: string | null): number | null {
   if (!dateStr) return null;
   const isoString = dateStr.replace(" ", "T");
   const millis = new Date(isoString).getTime();
   return isNaN(millis) ? null : millis;
}

export const getCaseStatus = (
   start: string | null,
   deadlineDate?: string,
   duration?: number,
): CaseColorStatus => {
   const plannedTimeInMillis = dateStringToMillis(start);
   const deadlineInMillis = dateStringToMillis(deadlineDate);
   const currentTime = Date.now();
   const realisationTimeInMillis = (duration ?? 0) * ONE_MINUTE_IN_MILLIS;

   const notPlanned = plannedTimeInMillis === null;

   if (notPlanned && deadlineInMillis !== null) {
      return "overdue";
   }

   if (notPlanned) {
      return "normal";
   }

   if (deadlineInMillis !== null && currentTime > deadlineInMillis) {
      return "overdue";
   }

   const realisationDate = plannedTimeInMillis + realisationTimeInMillis;
   if (currentTime > realisationDate) {
      return "delayed";
   }

   return "future";
};
